import { cn } from '@workspace/ui/lib/utils';
import React from 'react';
import { company } from '~/company/Company';
import { useStatusBarControl } from '~/hooks/useStatusBarControl';

// I'm not sure why, but it's not working with ComponentPropsWithRef<'header'>
type EmptyHeaderProps = React.HTMLAttributes<HTMLHeadingElement>;

const EmptyHeader = React.forwardRef<HTMLHeadingElement, EmptyHeaderProps>(
  (props, ref) => {
    useStatusBarControl({
      initialColor: 'light-content',
      scrolledColor: 'dark-content',
      scrollThreshold: 50,
    });

    return (
      <header
        {...props}
        ref={ref}
        className={cn(
          'h-auto w-full bg-graphic-regular-black',
          company.match({
            mcosmetic: 'min-h-0 pt-safe',
            default: 'min-h-4 pt-safe-offset-4',
          }),
          props.className,
        )}
      />
    );
  },
);
EmptyHeader.displayName = 'EmptyHeader';

export default EmptyHeader;
